import { getSectionIndexPath } from '../../../config/localeRoutes';

export function buildBreadcrumbSchema({ siteUrl, page, contentPage, pageUrl, sectionLabels, locale = 'fr' }) {
  if (page === 'home') return null;

  const homeLabel = locale === 'en' ? 'Home' : 'Accueil';
  const pageName = contentPage?.title || page;
  const homeUrl = locale === 'en' ? `${siteUrl}/en/` : `${siteUrl}/`;
  const isHubSection = contentPage?.section === 'hub' || contentPage?.section === 'hub-en';

  if (page === 'content' && isHubSection) {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: homeLabel,
          item: homeUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: pageName,
          item: pageUrl,
        },
      ],
    };
  }

  if (page === 'content' && contentPage?.section) {
    const sectionIndexPath = getSectionIndexPath(contentPage.section);

    if (!sectionIndexPath) {
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: homeLabel,
            item: homeUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: pageName,
            item: pageUrl,
          },
        ],
      };
    }

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: homeLabel,
          item: homeUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: sectionLabels[contentPage.section] || contentPage.section,
          item: `${siteUrl}${sectionIndexPath}`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: pageName,
          item: pageUrl,
        },
      ],
    };
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: homeLabel,
        item: homeUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: pageName,
        item: pageUrl,
      },
    ],
  };
}
